import FuiSliderModifier from "wise-fui-modules/modifiers/fui-slider";
export default class FeelingEvaSliderModifier extends FuiSliderModifier {
  modify(...args) {
    super.modify(...args);

    // Do nothing if we are not in `touch` mode
    if (!this.jqueryObject.data().moduleSlider.is.touch()) return;

    // Unbind `touchstart` events on the element `.inner`, `.track` as well as on the root slider element itself
    // to prevent a scroll attempt to change the slider value
    this.jqueryObject.find(".track, .inner").off("touchstart.slider");
    this.jqueryObject.off("touchstart.slider");
  }
}